export default "__VITE_ASSET__CZ20QMTp__"